import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfOttawa = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Ottawa (uOttawa)"
      universityShortName="uOttawa"
      slug="university-of-ottawa"
      seoTitle="uOttawa Study Rooms | Ottawa Campus Library Study Guide"
      seoDescription="Complete guide to study rooms at University of Ottawa. Find Morisset Library, CRX, FSS building study spaces. Plus free 24/7 online alternative."
      seoKeywords="uottawa study rooms, university of ottawa library, morisset library, crx building, fss building, ottawa university study spaces"
      canonicalUrl="/study-room/university-of-ottawa/"
      heroDescription="A comprehensive guide to study rooms and spaces at uOttawa, including Morisset Library, CRX, and the FSS building."
      libraryWebsiteUrl="https://biblio.uottawa.ca/"
      libraryWebsiteName="uOttawa Library"
      studySpaces={[
        {
          name: "Morisset Library",
          features: "Quiet spaces with desk dividers for focused individual study.",
          feedback: "Can feel claustrophobic due to artificial lighting; upper floors are quieter."
        },
        {
          name: "Learning Crossroads (CRX)",
          features: "Popular building with natural light, comfortable chairs, and bookable rooms.",
          feedback: "Bright but noisy during peak hours; great for group work."
        },
        {
          name: "Faculty of Social Sciences (FSS) Building",
          features: "Living-plant wall and numerous seating options; FSS Library has statistical software.",
          feedback: "Bright and modern; can have constant keyboard noise in library areas."
        },
        {
          name: "Hamelin-Simard Bridge",
          features: "Tranquil walkway with hidden sunlit spots.",
          feedback: "A hidden gem for peaceful studying with natural light."
        },
        {
          name: "Lamoureux Hall",
          features: "Cafeteria-style space with Thai Express.",
          feedback: "Food smells and chatter can be distracting; not ideal for focused work."
        },
        {
          name: "SITE Building",
          features: "Tech-focused building with Tim Hortons.",
          feedback: "Good for tech students; busy during class hours."
        },
        {
          name: "Desmarais Building",
          features: "Pods and tables for various study styles.",
          feedback: "Versatile space; can be crowded between classes."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            For silence, head to <strong>Morisset's upper floors</strong>. <strong>CRX</strong> is perfect for group work if you don't mind a crowd.
          </p>
          <p className="mb-4">
            Try the <strong>Hamelin-Simard bridge</strong> for a hidden sunlit spot, and avoid <strong>Lamoureux at lunchtime</strong> if you're sensitive to food smells.
          </p>
          <p>
            The <strong>FSS Library</strong> offers statistical software but expect constant keyboard noise.
          </p>
        </>
      }
      summaryTips={[
        "Go to Morisset's upper floors for quiet: The library can feel claustrophobic but upper floors are peaceful.",
        "Use CRX for group work: Natural light and comfortable chairs, though noisy at peak hours.",
        "Find the Hamelin-Simard bridge: A hidden sunlit spot for tranquil studying.",
        "Avoid Lamoureux at lunchtime: Food smells can be distracting.",
        "Use CSW for guaranteed focus: Virtual study rooms offer distraction-free studying."
      ]}
    />
  );
};

export default UniversityOfOttawa;
